<app-fullpage-loading *ngIf="loading" ></app-fullpage-loading>
<router-outlet></router-outlet>